var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{attrs:{"items":_vm.accountCodeList,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('tr',[_c('td',[_vm._v(_vm._s(item.parent_code))]),_c('td',[_vm._v(_vm._s(item.account_code))]),_c('td',[_vm._v(_vm._s(item.description))])])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }